import Immutable from 'seamless-immutable';
// ---- external imports ----

import * as types from './actionTypes';
// ---- local imports ----

const INITIAL_PRODUCT_SALES_FOR_MONTH = {
	couch: {
		amount: 0
	},
	chair: {
		amount: 0
	},
	table: {
		amount: 0
	},
};

const initialState = Immutable({
	couch: {},
	chair: {},
	table: {},
	productSalesForCurrMonth: INITIAL_PRODUCT_SALES_FOR_MONTH,
	isLoaded: false
});

export default function reduce(state = initialState, action = {}) {
	switch (action.type) {
	case types.PRODUCTS_LOADED:
		return state.merge({
			...action.products,
			isLoaded: true
		});
	case types.PRODUCTS_SALES_DATA_LOADED:
		return state.merge({
			productSalesForCurrMonth: action.productSalesForCurrMonth
		});
	case types.PRODUCTS_PURCHASED:
		return state;
	case types.PRODUCTS_RESET_MONTHLY_SALES:
		return state.merge({
			productSalesForCurrMonth: INITIAL_PRODUCT_SALES_FOR_MONTH
		});
	case types.PRODUCTS_UPDATE_COUCH_SELLING_PRICE:
		return state.merge({
			couch: {
				sellingPrice: action.newSellingPrice
			}
		}, { deep: true });
	case types.PRODUCTS_UPDATE_CHAIR_SELLING_PRICE:
		return state.merge({
			chair: {
				sellingPrice: action.newSellingPrice
			}
		}, { deep: true });
	case types.PRODUCTS_UPDATE_TABLE_SELLING_PRICE:
		return state.merge({
			table: {
				sellingPrice: action.newSellingPrice
			}
		}, { deep: true });
	case types.PRODUCTS_SOLD_COUCH: {
		const amount = state.productSalesForCurrMonth.couch.amount + 1;

		return state.merge({
			couch: {
				amount: action.amount
			},
			productSalesForCurrMonth: {
				...state.productSalesForCurrMonth,
				couch: { amount }
			}
		}, { deep: true });
	}
	case types.PRODUCTS_COUCH_PURCHASED:
		return state.merge({
			couch: {
				amount: action.amount
			}
		}, { deep: true });
	case types.PRODUCTS_SOLD_CHAIR: {
		const amount = state.productSalesForCurrMonth.chair.amount + 1;

		return state.merge({
			chair: {
				amount: action.amount
			},
			productSalesForCurrMonth: {
				...state.productSalesForCurrMonth,
				chair: { amount }
			}
		}, { deep: true });
	}
	case types.PRODUCTS_CHAIR_PURCHASED:
		return state.merge({
			chair: {
				amount: action.amount
			}
		}, { deep: true });
	case types.PRODUCTS_SOLD_TABLE: {
		const amount = state.productSalesForCurrMonth.table.amount + 1;

		return state.merge({
			table: {
				amount: action.amount
			},
			productSalesForCurrMonth: {
				...state.productSalesForCurrMonth,
				table: { amount }
			}
		}, { deep: true });
	}
	case types.PRODUCTS_TABLE_PURCHASED:
		return state.merge({
			table: {
				amount: action.amount
			}
		}, { deep: true });
	default:
		return state;
	}
}
